import {
	Box,
	Button,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
	TextField,
	Typography,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";

import React from "react";
import { sizes } from "./editScenarioNewUtils";
import { useDispatch, useSelector } from "react-redux";
import { getProductGroup, setState } from "./editScenarioNewSlice";

const commonHeight = sizes.h35;
const SW = sizes.w300;

export default function SkuPgSearchForm() {
	const dispatch = useDispatch();
	const setupState = useSelector((store) => store.editScenarioNew);
	const {
		skuCategories,
		selectedSKUCategory,
		sku_PG_Name,
		selectedCountry,
		countryID,
	} = setupState;

	const handleSKUCategorySelection = (event) => {
		if (selectedCountry.length <= 0) {
			showMessage("Please select a country first", "info");
			return;
		}
		const value = event.target.value;
		dispatch(setState("selectedSKUCategory", value));
	};

	const handleSearchPG = () => {
		if (selectedCountry.length <= 0) {
			showMessage("Please select a country first", "info");
			return;
		}
		dispatch(setState("productGroups", []));
		dispatch(setState("is_sku_refresh", true));
		dispatch(getProductGroup({ countryID, sku_PG_Name }));
	};

	const handleStateUpdate = (event, stateName) => {
		const value = event.target.value;
		dispatch(setState(stateName, value));
	};

	const showMessage = (message, severity) => {
		dispatch(setState("message", message));
		dispatch(setState("severity", severity));
		dispatch(setState("messageOpen", true));
	};

	return (
		<Box>
			
				{/* <Typography className="compHeading" variant="subtitle1" sx={{ color: "black.main", fontWeight: "bold", fontSize:"14px" }}>
					Select SKUs/Product Groups
				</Typography> */}
			
			<Grid container columns={12} justifyContent="flex-start" alignItems="center" spacing={2} pb={2} mt={.5}>
				<Grid item xs={6} sm={6} md={5} lg={5.9} mt={1} >
					<Box>
						<FormControl sx={{width: '100%',}}>
							<InputLabel id="demo-simple-select-label">
								Select SKU Category
							</InputLabel>
							<Select
								labelId="demo-simple-select-label"
								id="demo-simple-select"
								value={selectedSKUCategory}
								label="Country"
								// sx={{
								// 	height: commonHeight,
								// 	width: SW,
								// 	color: "black.main",
								// 	mt: 1,
								// }}
								sx={{ mt: .6, width: '100%',}}
								onChange={handleSKUCategorySelection}
								className="montserratFont"
							>
								{skuCategories.map((category, index) => {
									return (
										<MenuItem key={index} value={category}>
											{category}
										</MenuItem>
									);
								})}
							</Select>
						</FormControl>
					</Box>
				</Grid>
				<Grid item xs={6} sm={6} md={5} lg={4.8} mt={1}>
					<Box>
					<TextField sx={{ width: '100%',}}
						id="outlined-basic"
						label="Search SKU/Product Group"
						variant="outlined"
						value={sku_PG_Name}
						onChange={(event) =>
							handleStateUpdate(event, "sku_PG_Name")
						}
					/>
					</Box>
				</Grid>
				<Grid item xs={6} sm={6} md={1} lg={1.1} mt={1} >
					<Box>
						<Button
							startIcon={<SearchIcon />}
							sx={{
								bgcolor: "blue.main",
								color: "white.main",
								"&:hover": {
									bgcolor: "lightBlue.main"
								},
							}}
							onClick={handleSearchPG}
						>
							Search
						</Button>
					</Box>
				</Grid>
			</Grid>
		</Box>
	);
}
